const setCurrentTokenValue = ({ commit }, payload) => {
  commit('setCurrentTokenValue', payload)
}

export default {
  setCurrentTokenValue,
  'QUIZ/ANSWER_RESULT': () => { },
  BUTTON_CLICK: () => { },
}
